<div class="inputTitle" *ngIf="label">
  <span>{{ label }}
      <i MatSuffix matTooltip={{tooltipName}} matTooltipPosition="right" [matTooltipHideDelay]="delay" id="i1"
         class="flaticon-message" *ngIf="tooltipIcon"></i>
  </span>
</div>

<mat-form-field [class.has-errors]="errors?.length" appearance="outline" *ngIf="isEditable"
                [class.errorBorder]="errors?.length">
    <input matInput [matDatepicker]="picker" id="input2" placeholder="DD/MM/YYYY" [ngModel]="momentObj"
           (ngModelChange)="setDate($event)" [min]="minDate" [max]="maxDate" onpaste="return false;"
           ondrop="return false;"
           (keydown)="$event.preventDefault();" [disabled]="disabled" (dateChange)="dateChanged($event)">
    <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="disabled"></mat-datepicker-toggle>
    <mat-datepicker #picker [disabled]="disabled"></mat-datepicker>
</mat-form-field>

<div class="viewLable" *ngIf="!isEditable">
    <span>{{ dateToString() }}</span>
</div>

<ul *ngIf="errors?.length" class="errorList">
    <li *ngFor="let item of errors" class="error">{{ item }}</li>
</ul>
